import { Box, Flex, Select, Skeleton, Text } from '@chakra-ui/react'
import { CircleFlag } from 'react-circle-flags'
import { phoneNumbers } from '../../../utils/constants/PhoneDial'

interface CountrySelectWithFlagProps {
  value: string
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
  name: string
  isLoading?: boolean
  isDisabled?: boolean
  height?: string
  mb?: string
}

const CountrySelectWithFlag = ({
  value,
  onChange,
  name,
  isLoading = false,
  isDisabled = false,
  height = '40px',
  mb = '16px',
}: CountrySelectWithFlagProps) => {
  const selectedCountry = phoneNumbers.find((country) => country.code === value)
  const countryCode = selectedCountry?.code.toLowerCase() || ''

  if (isLoading) {
    return <Skeleton height={height} mb={mb} />
  }

  return (
    <Box position="relative" height={height} mb={mb}>
      <Flex
        align="center"
        h={height}
        pl="12px"
        bg="white"
        borderWidth="1px"
        borderColor="inherit"
        borderRadius="md"
        position="absolute"
        width="100%"
        zIndex="1"
        pointerEvents="none"
      >
        {value ? (
          <>
            <CircleFlag countryCode={countryCode} height="16" width="16" />
            <Text ml="8px" fontSize="14px">
              {selectedCountry?.name || ''}
            </Text>
          </>
        ) : (
          <Text color="gray.500" fontSize="14px">
            Select a country
          </Text>
        )}
      </Flex>

      <Select
        h={height}
        name={name}
        value={value}
        onChange={onChange}
        isDisabled={isDisabled}
        position="absolute"
        width="100%"
        zIndex="2"
        opacity="0"
        cursor="pointer"
      >
        <option value="">Select a country</option>
        {phoneNumbers.map((country) => (
          <option key={country.code} value={country.code}>
            {country.name}
          </option>
        ))}
      </Select>
    </Box>
  )
}

export default CountrySelectWithFlag
